import React from 'react';
export default (function (_a) {
    var prefix = _a.prefix, href = _a.href, children = _a.children;
    return (React.createElement("div", { className: "AlertBar AlertBar--hasContent" },
        React.createElement("div", { className: "AlertBar__container container" },
            React.createElement("div", { className: "AlertBar__labelContainer" }, prefix)),
        React.createElement("div", { className: "AlertBar__linkContainer h-100" },
            React.createElement("a", { className: "AlertBar__link carousel-cell w-100 h-100", href: href },
                React.createElement("div", { className: "AlertBar__container container h-100" },
                    React.createElement("div", { className: "AlertBar__row row no-gutters h-100" },
                        React.createElement("div", { className: "AlertBar__content col" }, children)))))));
});
